import React from "react";
import Select from "react-select";
import { connect } from "react-redux";
import {
  selectUsersByIds,
  selectUsersByParams
} from "../../redux/selectors/users";

class SelectStudents extends React.Component {
  handleChange = selectedOptions => {
    const selected = selectedOptions.map(val => val.value);
    this.props.setFieldValue(`studentIds`, selected);
  };

  render() {
    const { normUsers, selectedUsers } = this.props;

    return (
      <React.Fragment>
        <Select
          {...this.props}
          isMulti
          isSearchable
          onChange={this.handleChange}
          defaultValue={selectedUsers}
          options={normUsers}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const users = selectUsersByParams(state, { ...ownProps });
  const selectedUsers = selectUsersByIds(state, ownProps.values.studentIds).map(
    user => ({
      value: user.key,
      label: `${user.nombre} ${user.nivel}${user.identificadorNivel} ${
        user.colegio
      }`
    })
  );

  const normUsers = users.map(user => ({
    value: user.key,
    label: `${user.nombre} ${user.nivel}${user.identificadorNivel} ${
      user.colegio
    }`
  }));

  return {
    normUsers,
    selectedUsers
  };
};

export default connect(mapStateToProps)(SelectStudents);
